import { useApiFeatureFlag } from '@/hooks/useFeatureFlag'
import type { DocumentRecord } from '@/types/catalog'

export const EXPLAIN_VIDEO_FLAG = 'explain_video_enabled'

/** Rows a brief cannot be made from: derived artifacts and anchors with no file. */
const NOT_A_SOURCE = new Set(['graph', 'video', 'live_stream'])

/**
 * A local `just up` serves the app from the Vite dev server, where PostHog is
 * disabled by design (posthog-config.ts), so a PostHog flag can never turn on
 * there. The feature is on in that one mode; every deployed build is a
 * production bundle and the flag alone decides. Vitest runs in mode `test`.
 */
export const LOCAL_DEV_MODE = import.meta.env.MODE === 'development'

/**
 * Whether "Explain as video" is offered to this person: the PostHog flag, or
 * the local dev server. The API applies the same two rules.
 */
export function useExplainAsVideoEnabled(): boolean {
  const { enabled } = useApiFeatureFlag(EXPLAIN_VIDEO_FLAG, false)
  return enabled || LOCAL_DEV_MODE
}

/**
 * Whether "Explain as video" applies to this catalog row. Mirrors the server's
 * rule in `VideoBriefRequestService`: a processed file of any real type. A row
 * still processing has nothing a brief could be cut from yet.
 */
export function canExplainAsVideo(doc: Pick<DocumentRecord, 'type' | 'status'>): boolean {
  if (NOT_A_SOURCE.has(doc.type)) return false
  return doc.status === 'success'
}
